import visa from '../../../../public/payment/visa.webp';
import discover from '../../../../public/payment/discover.webp';
import mastercard from '../../../../public/payment/mastercard.webp';
import dinerclub from '../../../../public/payment/DinerClub.webp';
import paypal from '../../../../public/payment/paypal.webp';
import amex from '../../../../public/payment/AmericanExp.webp';
import Image from 'next/image';

export default function PaymentMethods({ regionalText }) {
  return (
    <div className="rounded-md text-center my-2">
      <p className="mb-2 font-bold">{regionalText}</p>
      <div className="flex flex-row justify-around px-1 gap-1 items-center bg-white shadow-md h-20 lg:-mx-12">
        <div className="flex-1">
          <Image
            src={visa}
            alt="Visa"
            title="Visa"
            width={80}
            height={'auto'}
          />
        </div>
        <div className="flex-1">
          <Image
            src={discover}
            alt="Discover"
            title="Discover"
            width={80}
            height={'auto'}
          />
        </div>

        <div className="flex-1">
          <Image
            src={mastercard}
            alt="MasterCard"
            title="MasterCard"
            width={80}
            height={'auto'}
          />
        </div>
        <div className="flex-1">
          <Image
            src={amex}
            alt="AmericanExpress"
            title="AmericanExpress"
            width={80}
            height={'auto'}
          />
        </div>
        <div className="flex-1">
          <Image
            src={dinerclub}
            alt="Diners Club"
            title="Diners Club"
            width={80}
            height={'auto'}
          />
        </div>
        <div className="flex-1">
          <Image
            src={paypal}
            alt="PayPal"
            title="PayPal"
            width={80}
            height={'auto'}
          />
        </div>
      </div>
    </div>
  );
}
